// Canonical fence-style / fence-type mapping shared by NexusGoogle, NexusGeoDetails
// and NexusGeoFence. Matches the "Fence Style" Radio.Group: value="1" -> Circle,
// value="2" -> Polygon.
export const FENCE_STYLE = {
  CIRCLE: "1",
  POLYGON: "2",
};

export const FENCE_TYPE = {
  CIRCLE: "circle",
  POLYGON: "polygon",
};

export const FENCE_TYPE_LABELS = {
  [FENCE_TYPE.CIRCLE]: "Circle",
  [FENCE_TYPE.POLYGON]: "Polygon",
};

export const fenceTypeToStyle = (fenceType) =>
  fenceType === FENCE_TYPE.CIRCLE ? FENCE_STYLE.CIRCLE : FENCE_STYLE.POLYGON;

export const fenceStyleToType = (fenceStyle) =>
  fenceStyle === FENCE_STYLE.CIRCLE ? FENCE_TYPE.CIRCLE : FENCE_TYPE.POLYGON;
